import React, { useEffect, useState } from "react";
import { withSnackbar } from "notistack";

import Btn from "components/Custom/Btn";
import RadioBtn from "components/Custom/RadioBtn";
import { NOTIFY } from "common/config";
import { LABELS, WARNINGS, TITLES, SUB_TITLES } from "common/lables";

import { COLORS } from "common/colors";

const TDSConfirmation = (props: any) => {
  const { setDashMenu } = props;

  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  console.log("Page: TDS Confirmation:");

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>
            {LABELS.ACCOUNT}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.TDS_CONFIRMATION}</li>
        </ul>
        <h4>{TITLES.TDS_CONFIRMATION}</h4>
        <p>{SUB_TITLES.TDS_CONFIRMATION}</p>
      </div>

      <div className="hChart">
        <div
          style={{ width: "100%", display: "flex", flexDirection: "column" }}
        >
          <div
            className="formGroup"
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: 0,
              marginBottom: 20,
            }}
          >
            <p>I confirm that my Turnover for current year is </p>
            <div>
              <RadioBtn
                list={[
                  {
                    id: "greaterThan",
                    value: "GreaterThan",
                    label: "> 10 crores",
                    checked: true,
                    disabled: false,
                  },
                  {
                    id: "lessThan",
                    value: "lessThan",
                    label: "< 10 crores",
                    disabled: false,
                  },
                ]}
                name={"allCombined"}
              />
            </div>
          </div>
          <div>
            <Btn text={LABELS.SAVE} onClick={""} bgColor={COLORS.SAVE_GREEN} />
          </div>
        </div>
      </div>
      {/* {mandatoryResults.length > 0 && (
        <div className="mandatoryBox">
          <ul>
            {mandatoryResults.map((m) => {
              return (
                <li>
                  <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                </li>
              );
            })}
          </ul>
        </div>
      )} */}
    </React.Fragment>
  );
};

export default withSnackbar(TDSConfirmation);
